export const INGREDIENTS_PENDING = "ingredients/INGREDIENTS_PENDING";
export const INGREDIENTS_FULFILLED = "ingredients/INGREDIENTS_FULFILLED";
export const VIEW_INGREDIENT = "ingredients/VIEW_INGREDIENT";
export const HIDE_INGREDIENT = "ingredients/HIDE_INGREDIENT";
